var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 24v2.667l2.667 1.333v1.333h-10.667l-0.005-1.328 2.672-1.339v-2.667h-9.344c-0.731-0.005-1.323-0.599-1.323-1.331 0-0.004 0-0.008 0-0.013v0.001-17.315c0-0.741 0.607-1.343 1.323-1.343h24.021c0.731 0 1.323 0.599 1.323 1.343v17.315c0 0.741-0.607 1.343-1.323 1.343h-9.344zM5.333 6.667v12h21.333v-12h-21.333z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfx);
export default __webpack_public_path__ + "static/media/vfx.222c4bb0744e103944bc55e830eafee5.svg";
export { ForwardRef as ReactComponent };